<button
  mat-mini-fab
  class='menu-notification-badge'
  color='primary'
  vrm-bg-color
  [matTooltip]='this.tooltip | translate'
  [matMenuTriggerFor]='dvcrNotificationsMenu'
>
  <small style='position: relative; bottom: 2px'>{{ notificationData.total }}</small>
</button>

<!-- DVCR Only -->
<mat-menu #dvcrNotificationsMenu='matMenu' class='menu-notification-menu'>
  <div *ngIf="id === 'DVCR'">
    <!-- S1 Damage -->
    <button mat-menu-item [disableRipple]='true'>
      {{ 'DVCR.sOneDamage' | translate }}

      <button
        mat-flat-button
        style='background-color: #df2828; color: white'
        class='menu-notification-menu-damage-btn'
        [disableRipple]='true'
      >
        {{ notificationData.dvcrDamageDetailsS1 }}
      </button>
    </button>

    <!-- S2 Damage -->
    <button mat-menu-item [disableRipple]='true'>
      {{ 'DVCR.sTwoDamage' | translate }}

      <button
        mat-flat-button
        style='background-color: #f1c410; color: white'
        class='menu-notification-menu-damage-btn'
        [disableRipple]='true'
      >
        {{ notificationData.dvcrDamageDetailsS2 }}
      </button>
    </button>
  </div>
</mat-menu>
